import { MultigameParams } from "../../MultigameParams";
import { ExpandingWildsBulk, ExpandingWildsBulkConfig, ExpandingWildsBulkFactory, ExpandingWildsBulkParam } from "../../slot/ExpandingWildBulk";
import { RewardColor } from "../../slot/ScatterRandomAward/RewardOptionFactory";
import { SlotGameInitData } from "../../SlotGameInitData";
import { SlotGameType1 } from "../SlotGameType1";
import { Rect } from "../.././MyHelpers";
import { Help, HelpPanelColor, HelpParameters } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";
import { PickBonusState } from "../PickBonus/PickBonusState";
import { PickBonusMessages } from "../PickBonus/PickMessage";

// namespace SlotGames {

	export class RapidLavaLand extends SlotGameType1 {

		// //protected override freegameBonusFactory: FreegameBonusFactory = new RapidLavaLandFreegameBonusFactory();
		// protected override expandingWildsFactory: ExpandingWildsBulkFactory = new RapidLavaLandExpandingWildsBulkFactory();
		// protected override pickBonusFactory: PickBonusFactory = new RapidLavaLandPickBonusFactory();
		
		// //protected panelFactory:IPanelFactory = new RapidLavaLandPanelFactory();
		// protected override helpFactory:IHelpFactory = new RapidLavaLandHelpFactory();
		//LED COLOR
		protected override ColorLed:string="137,0,0\n";
	
	
		//SEND COLOR 
        protected override color: RewardColor = 
        {
            color: "white",
            coloroutherStroke: "black",
            colorinnerStroke: "red",
        }

		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "RapidLavaLand");

			this.spinnableReelsParams.topBorderWidth = 10;
			this.spinnableReelsParams.bottomBorderWidth = 10;
		}
	}

	// class RapidLavaLandFreegame extends FreegameBonus {
	// 	protected override plusOneAnimFactory: IPlusOneFactory = new SpritePlusOneFactory();

	// 	public constructor(gameName: string, params: FreegameBonusParams) {
	// 		super(gameName, params);
	// 		this.spinnableReelsParams.topBorderWidth = 7;
	// 		this.spinnableReelsParams.bottomBorderWidth = 7;
	// 	}

	// 	protected override PrepareFonts(resourceManager: ResourceManager): void {
	// 		resourceManager.Add(new FontResource(this.params.commonBonusResourcesBasePath + "resources/newzone.ttf", this.resid.ScopedResourceName("bigwincount")));
	// 		resourceManager.Add(new FontResource(this.params.gameBonusResourcesBasePath + "AXR Neverland Shadow.ttf", this.resid.ScopedResourceName(["lines", "font"])));
	// 	}

	// 	protected override PicksPositions(): FreegamePickElemGeometry[] {
	// 		let geometry: FreegamePickElemGeometry[] = [];

	// 		let displayWidth: number = 394;
	// 		let displayHeight: number = 441;

	// 		let displayRects: PixelRect[] =
	// 			[
	// 				new PixelRect(21, 328, displayWidth, displayHeight),
	// 				new PixelRect(363, 528, displayWidth, displayHeight),
	// 				new PixelRect(705, 328, displayWidth, displayHeight),
	// 				new PixelRect(1044, 528, displayWidth, displayHeight),
	// 				new PixelRect(1386, 328, displayWidth, displayHeight),
	// 			];

	// 		// offset relative to pick rect
	// 		let pickRect = new PixelRect(35, 112, 333, 201);
	// 		let awardRect = new PixelRect(79, 87, 262, 261);

	// 		for (let i = 0; i < displayRects.length; i++) {
	// 			geometry.push(new FreegamePickElemGeometry(displayRects[i], pickRect, awardRect));
	// 		}

	// 		return geometry;
	// 	}

	// 	public override OnPicked(index: number): void {
	// 		//super.OnPicked(index);

	// 		if (this.stateMachine.State() == FreegameStates.Pick) {
	// 			// Log.Debug(this.logGroup, "Picked index " + index);

	// 			// TODO check state, check index bounds
	// 			this.pickedIndex = index;
	// 			// protocol.Send("SelectBonusElement",{selectedElement: index});

	// 			for (let i = 0; i < this.picks.length; i++) {
	// 				if (i == index) {
	// 					this.picks[i].BringToFront();
	// 					this.picks[i].awardElem.style.fontSize = "150px";
	// 					this.picks[i].awardElem.style.left = "71px";
	// 					this.picks[i].awardElem.style.top = "92px";
	// 				}

	// 				else {
	// 					this.picks[i].PushToBack();
	// 					this.picks[i].awardElem.style.fontSize = "50px";
	// 					this.picks[i].awardElem.style.left = "71px";
	// 					this.picks[i].awardElem.style.top = "92px";
	// 				}
	// 			}

	// 			this.stateMachine.ChangeState(FreegameStates.RevealPicked);
	// 		}
	// 	}

	// 	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
	// 		await super.ResourcesLoaded(resourceManager);

	// 		//this.pickElem.innerHTML = "BOTTLE";

	// 		//SetStyles(this.view.querySelectorAll(".dialog"),{width:})


	// 		// this.introMessageContainer.style.color = "(255,219,1)";
	// 		// this.introMessageContainer.style.webkitTextStrokeWidth = "1px";
	// 		// this.introMessageContainer.style.webkitTextStrokeColor = "black";
	// 		// this.finalMessageContainer.style.textShadow="black 0px 1px 1px";
			
	// 		// this.pickedMessageContainer.style.webkitTextStrokeWidth="1px";
	// 		// this.pickedMessageContainer.style.webkitTextStrokeColor = "black"
	// 		// this.pickedMessageContainer.style.textShadow="black 0px 1px 1px";
	// 		// this.finalMessageContainer.style.webkitTextStrokeWidth="2px";
	// 		// this.finalMessageContainer.style.webkitTextStrokeColor = "black";
	// 		// this.finalMessageContainer.style.textShadow="black 0px 1px 1px";
				
	// 		// SetStyles(this.view.querySelector("#startfree3"), { fontSize:"35px" });
	// 		// SetStyles(this.view.querySelectorAll("#contents3"), { fontSize:"30px", bottom:"175px" });
	// 		// SetStyles(this.view.querySelectorAll(".header"), { fontSize:"60px", lineHeight:"145px" });
	// 		// SetStyles(this.view.querySelector(".bonusName").parentElement, { fontSize:"60px", lineHeight: "100px", });
	// 		// SetStyles(this.view.querySelector("#startfree1"), { fontSize:"40px" });
	// 		// SetStyles(this.view.querySelector("#startfree2"), { fontSize:"40px" });
	// 		// SetStyles(this.view.querySelectorAll("#startfree3"),{fontSize:"32px",bottom:"175px"})
	// 		// SetStyles(this.view.querySelector("#contents1"), { fontSize:"32px", lineHeight: "40px" });
	// 		// SetStyles(this.view.querySelector("#contents2"), { fontSize:"32px", lineHeight: "32px" });
	// 		// SetStyles(this.view.querySelector("#headerend"), { fontSize:"73px" });
	// 		// SetStyles(this.view.querySelector("#startend3"), { fontSize:"40px",bottom:"175px" });
	// 		// SetStyles(this.view.querySelectorAll(".bonusName"),{fontSize:"60px"});
	// 		// SetStyles(this.view.querySelectorAll(".numPickedFreegames"),{fontSize:"70px"});
	// 		// SetStyles(this.view.querySelectorAll(".message"),{lineHeight:"130px", marginTop:"130px"});
	// 		// SetStyles(this.view.querySelectorAll(".contents1"),{lineHeight:"50px"});

	// 		// // pick instructions on pick screen
	// 		// SetStyles(this.view.querySelector(".pickInstructions .pick1"), {lineHeight: "100px"});
	// 	}
	// }
	// /*Finish Freegame*/

	// class RapidLavaLandExpandingWildsBulk extends ExpandingWildsBulk {
	// 	public override InflateWildSize(wildRect: Rect): Rect {
	// 		return wildRect;
	// 	}
	// }



	// class RapidLavaLandFreegamePickElement extends FreegamePickElement {

	// }


	// class RapidLavaLandFreegameBonusFactory extends FreegameBonusFactory {
	// 	public override CreateFreegameBonus(gameName: string, params: FreegameBonusParams): FreegameBonus {
	// 		return new RapidLavaLandFreegame(gameName, params);
	// 	}

	// 	public override CreatePickElement(params: FreegamePickElementParams): FreegamePickElement {
	// 		return new RapidLavaLandFreegamePickElement(params);
	// 	}
	// }

	// class RapidLavaLandExpandingWildsBulkFactory extends ExpandingWildsBulkFactory {
	// 	public override CreateExpandingWildsBulk(param: ExpandingWildsBulkParam, config: ExpandingWildsBulkConfig): ExpandingWildsBulk {
	// 		return new RapidLavaLandExpandingWildsBulk(param, config);
	// 	}

	// }
	// // 
	// /**
	//  * PICK BONUS 
	//  */
	// class RapidLavaLandPickBonus extends PickBonus {
	// 	public override UpdateSpinSpeed(changeSpeedParams: ChangeSpeedParams) {
	// 		throw new Error("Method not implemented.");
	// 	}
	// 	public override OnPicked(index: number) {
	// 		super.OnPicked(index);
	// 		if (this.stateMachine.State() == PickBonusState.Pick) {

	// 			// Log.Debug(this.logGroup, "Picked index " + index);

	// 			// TODO check state, check index bounds
	// 			this.pickedIndex = index;
	// 			this.session.left--;
	// 			// protocol.Send("SelectBonusElement",{selectedElement: index});



	// 			this.screenProtocol.Send(new PickBonusMessages.PickMessage(this.session), this.screenProtocolScope);

	// 			this.audio.Play(this.resid.ScopedResourceName("pick"));

	// 			this.stateMachine.ChangeState(PickBonusState.RevealPicked);


	// 		}
	// 	}
	// }

	// class RapidLavaLandPickBonusElement extends PickBonusElement {
	// 	public override AwardElemePrepare() {
	// 		super.AwardElemePrepare();

	// 		/* this.awardElem.style.left = this.awardRect.x-10+ "px";
	// 		this.awardElem.style.top = this.awardRect.y-13 + "px";
	// 		this.awardElem.style.width = this.awardRect.width + "px";
	// 		this.awardElem.style.height = this.awardRect.height + "px"; */
	// 	}
	// 	/* public WaitAnimPick()
	// 	{
	// 		this.anim_waitpick = TweenMax.fromTo(this, 1, {myscale: 1}, {myscale: 1.2, yoyo: true, repeat: -1, ease: Power0.easeNone, paused: true});
	// 	} */
	// }

	// //Panel Colorized
	// class RapidLavaLandPanelFactory implements IPanelFactory
	// {
	// 	public CreateNewPanel(params: PanelParams):Panel
	// 	{
	// 		return new RapidLavaLandPanel(params);
	// 	}
	// }

	// class RapidLavaLandPanel extends Panel
	// {
	// 	protected override ButtonBackground():ButtonColors
	// 	{
	// 		let color:ButtonColors ={
	// 			backgroundButtonColor: "linear-gradient(rgb(38, 1, 1),rgb(89, 3, 3), rgb(140, 4, 4),rgb(89, 3, 3),rgb(38, 1, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
	// 			linearColor:"linear-gradient(to left , transparent, DarkOrange,transparent ) 0 10 100%",
	// 		};
			
	// 		return color;
	// 	}
	// }


	//Help Colorized
	// class RapidLavaLandHelpFactory implements IHelpFactory
	// {
	// 	public CreateNewHelp(params: HelpParameters):Help
	// 	{
	// 		return new  RapidLavaLandHelp(params);
	// 	}
	// }

	// class  RapidLavaLandHelp extends Help
	// {
	// 	protected override BackgroundPanel():HelpPanelColor
	// 	{
	// 		let color:HelpPanelColor = {
	// 			backgroundPanelColor: "linear-gradient(rgb(38, 1, 1),rgb(89, 3, 3), rgb(140, 4, 4),rgb(89, 3, 3),rgb(38, 1, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
	// 		};

	// 		return color;
	// 	}
	// }


	// class RapidLavaLandPickBonusFactory extends PickBonusFactory {
	// 	public override CreatePickBonus(gameName: string, params: PickBonusParams): PickBonus {
	// 		return new RapidLavaLandPickBonus(gameName, params);
	// 	}

	// 	public override CreatePickElement(params: PickBonusPickElementParams): PickBonusElement {
	// 		return new RapidLavaLandPickBonusElement(params);
	// 	}

	// }
// }
